module.exports = __webpack_public_path__ + "static/media/trainer3.4b91b327.jpg";